module.exports = __webpack_public_path__ + "static/media/swords-laser.a53c1542.svg";